import React, { useEffect, useState } from "react";
import {
  Layout,
  Button,
  Card,
  Tag,
  List,
  Image,
  Space,
  Spin,
  message,
} from "antd";
import { Header } from "antd/es/layout/layout";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import axios from "axios";
import { BASE_URL } from "../Config";

const ViewAsana = () => {
  const { id } = useParams();
  const [asana, setAsana] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate();

  // detect mobile
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/asanadetails/${id}`);
        const data = res.data;
        setAsana(data.asana || data);
      } catch (err) {
        console.log(err);
        message.error("Failed to load asana details");
      }
    };
    fetchData();
  }, [id]);

  if (!asana) {
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar collapsed={collapsed} role="admin" />

      <Layout
        style={{
          marginLeft: isMobile ? (collapsed ? "0px" : "200px") : "0px",
          transition: "0.3s ease",
        }}
      >
        {/* CONTENT */}
        <div style={{ padding: 20 }}>
          <Card
            style={{
              maxWidth: 900,
              margin: "0 auto",
              padding: 20,
              borderRadius: 12,
            }}
          >
            <h1>{asana.name}</h1>

            <Tag color="blue">{asana.level}</Tag>
            <Tag color="green">{asana.chakra}</Tag>

            <p style={{ marginTop: 10, fontSize: 16 }}>
              <b>Sanskrit:</b> {asana.sanskrit} <br />
              <b>Tamil:</b> {asana.tamil} <br />
              <b>English:</b> {asana.english}
            </p>

            <h3 style={{ marginTop: 20 }}>Pose Types:</h3>
            {asana.poseType?.map((t, index) => (
              <Tag key={index} color="purple">
                {t}
              </Tag>
            ))}

            <h3 style={{ marginTop: 20 }}>Main Image:</h3>
            <Image
              src={asana.mainImage}
              width={300}
              style={{ borderRadius: 12 }}
            />

            <h3 style={{ marginTop: 20 }}>How to Do</h3>
            <List
              bordered
              dataSource={asana.howToDo}
              renderItem={(item) => <List.Item>{item}</List.Item>}
            />

            <h3 style={{ marginTop: 20 }}>Benefits</h3>
            <List
              bordered
              dataSource={asana.benefits}
              renderItem={(item) => <List.Item>{item}</List.Item>}
            />

            <h3 style={{ marginTop: 20 }}>Precautions</h3>
            <List
              bordered
              dataSource={asana.precautions}
              renderItem={(item) => <List.Item>{item}</List.Item>}
            />

            <h3 style={{ marginTop: 30 }}>Variation Poses</h3>
            <Space direction="vertical" style={{ width: "100%" }}>
              {asana.variationPoses?.map((v, i) => (
                <Card key={i} style={{ borderRadius: 10 }}>
                  <h3>{v.name}</h3>
                  <p style={{ fontWeight: "500" }}>
                    Sanskrit:<span> {v.sanskrit} </span>
                  </p>
                  <p style={{ fontWeight: "500" }}>
                    Country Name: <span>{v.country}</span>{" "}
                  </p>
                  <p style={{ fontWeight: "500" }}>
                    English: <span>{v.english}</span>
                  </p>
                  <p style={{ fontWeight: "500" }}>
                    Pose Type: <span>{v.poseType}</span>
                  </p>
                  <p style={{ fontWeight: "500" }}>
                    Media Link:{" "}
                    <a target="_blank" href={v.mediaLink}>
                      {v.mediaLink}
                    </a>
                  </p>
                  {v.image && (
                    <Image
                      src={v.image}
                      width={200}
                      style={{ borderRadius: 10 }}
                    />
                  )}
                </Card>
              ))}
            </Space>

            <Button
              type="primary"
              style={{ marginTop: 20 }}
              onClick={() => navigate(`/edit-asana/${id}`)}
            >
              Edit Asana
            </Button>
          </Card>
        </div>
      </Layout>
    </Layout>
  );
};

export default ViewAsana;
